import { combineReducers } from 'redux';
import { IContactUsState } from '../../../../models/reduxState';
import { AttachmentsReducer as AttachmentsState } from './attachmentsReducer';
import { AutoSuggestReducer as AutoSuggestState } from './AutoSuggestReducer';
import { DafReducer as DafState } from './dafReducers';
import { ModalitySectionReducer as ModalitySectionState } from './modalitySectionReducer';
import { OcvReducer as OcvState } from './ocvReducer';
import { RequestDetailsReducer as RequestDetailsState } from './requestDetailsReducer';
import { RequestFeedbackReducer as RequestFeedbackState } from './requestFeedbackReducer';
import { RequestHistoryReducer as RequestHistoryState } from './requestHistoryReducer';
import { SelfHelpAlchemyReducer as SelfHelpAlchemyState } from './selfHelpAlchemyReducer';
import { SharedStateReducer as SharedState } from './sharedStateReducer';
import { UserNoticeReducer as UserNoticeState } from './userNoticeReducer';

export const ContactUsReducer = combineReducers<IContactUsState>({
    AutoSuggestState,
    SharedState,
    SelfHelpAlchemyState,
    ModalitySectionState,
    UserNoticeState,
    RequestDetailsState,
    RequestHistoryState,
    AttachmentsState,
    OcvState,
    RequestFeedbackState,
    DafState,
});
